import { __decorate } from "tslib";
import { Service } from 'typedi';
import { CompanyPlanTypes, LicenseTypes, PricingProducts, SubscriptionTerms, } from '../models';
import { termDiscounts, tierDiscounts, currencyConverterFactor, getTierByAmountOfPaidLicenses, basePricing, } from '../utils/pricing-data';
var PricingService = /** @class */ (function () {
    function PricingService() {
        var _a;
        var _this = this;
        this.getTermPrice = (_a = {},
            _a[SubscriptionTerms.Monthly] = function (inputs) { return _this.getPriceByTerm(inputs, 0); },
            _a[SubscriptionTerms.OneYear] = function (inputs) { return _this.getPriceByTerm(inputs, 1); },
            _a[SubscriptionTerms.TwoYears] = function (inputs) { return _this.getPriceByTerm(inputs, 2); },
            _a[SubscriptionTerms.ThreeYears] = function (inputs) { return _this.getPriceByTerm(inputs, 3); },
            _a[SubscriptionTerms.FiveYears] = function (inputs) { return _this.getPriceByTerm(inputs, 4); },
            _a);
    }
    PricingService.prototype.getPricing = function (inputs) {
        if (inputs.amountOfPaidLicenses === 0) {
            return 0;
        }
        this.validateInputs(inputs);
        var price = this.getTermPrice[inputs.subscriptionTerm](inputs);
        return this.getConvertedPrice(price);
    };
    PricingService.prototype.validateInputs = function (_a) {
        var licenseType = _a.licenseType, amountOfPaidLicenses = _a.amountOfPaidLicenses, planType = _a.planType;
        var product = this.getProductByLicenseType(licenseType);
        if (amountOfPaidLicenses < 0) {
            throw new Error('Amount of paid licenses can not be less than 0');
        }
        if (product === PricingProducts.Sitemate && planType === CompanyPlanTypes.Standard) {
            throw new Error('Standard plan is not available for Sitemate users');
        }
    };
    PricingService.prototype.getProductByLicenseType = function (licenseType) {
        if ([LicenseTypes.SitemateFreeUser, LicenseTypes.SitematePaidUser].includes(licenseType)) {
            return PricingProducts.Sitemate;
        }
        return PricingProducts.Dashpivot;
    };
    PricingService.prototype.getPriceByTerm = function (inputs, paymentTermIndex, currentPrice, currentIndex) {
        if (currentPrice === void 0) { currentPrice = this.getMonthlyPrice(inputs); }
        if (currentIndex === void 0) { currentIndex = 0; }
        if (currentIndex >= paymentTermIndex) {
            return currentPrice;
        }
        var nextPrice = currentPrice * (1 - termDiscounts[inputs.subscriptionTerm]);
        return this.getPriceByTerm(inputs, paymentTermIndex, nextPrice, currentIndex + 1);
    };
    PricingService.prototype.getMonthlyPrice = function (_a) {
        var amountOfPaidLicenses = _a.amountOfPaidLicenses, licenseType = _a.licenseType, planType = _a.planType, currency = _a.currency;
        var tier = getTierByAmountOfPaidLicenses(amountOfPaidLicenses);
        var product = this.getProductByLicenseType(licenseType);
        var basePrice = this.getBasePriceByPlanType(product, planType, currency);
        return basePrice - tierDiscounts[product][tier] * currencyConverterFactor[currency];
    };
    PricingService.prototype.getBasePriceByPlanType = function (product, planType, currency) {
        if (planType === CompanyPlanTypes.Standard) {
            return basePricing.dashpivot.standard[currency];
        }
        return basePricing[product][planType][currency];
    };
    PricingService.prototype.getConvertedPrice = function (amount) {
        var formatOptions = { minimumFractionDigits: 2, maximumFractionDigits: 2 };
        var value = new Intl.NumberFormat('en-US', formatOptions).format(amount);
        return Number(value);
    };
    PricingService = __decorate([
        Service()
    ], PricingService);
    return PricingService;
}());
export { PricingService };
